export default "__VITE_ASSET__CcVz3Hs8__"